import { easeQuadInOut } from 'd3-ease';
import dayjs from 'dayjs';
import React from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import CountUp from 'react-countup';
import { IoClose, IoWarningOutline } from 'react-icons/io5';
import { getAllMemberTaskTimeData, getAllTeamwiseData, getOverallAttendance, getOverallTaskCount, getPendingRatingTaskList, logout } from '../../service/service-call';
import AnimatedProgressProvider from '../Charts/AnimatedProgressProvider';
import BarChartStacked from '../Charts/BarChartStacked';
import MonthlyAttendanceChart from '../Charts/MonthlyAttendanceChart';
import PieChartForAttendance from '../Charts/PieChart';
import { PendingRatingTasks } from './pendingRatingTasks';

export default function Home() {
  const [pendingRatingTasks, setPendingRatingTasks] = React.useState([]);
  const [isPendingRatingTasksOpen, setIsPendingRatingTasksOpen] = React.useState(false);
  const [overAllCount, setOverallCount] = React.useState("");
  const [overallAttendance, setoverallAttendance] = React.useState([]);
  const [memberwiseData, setMemberwiseData] = React.useState([]);
  const [teamwiseData, setTeamwiseData] = React.useState([]);
  const [attendanceDate, setAttendanceDate] = React.useState(
    dayjs().format("YYYY-MM-DD")
  );
  const [monthlyAttendance, setMonthlyAttendance] = React.useState([]);
  const [attendanceMonth, setAttendanceMonth] = React.useState(dayjs());

  function togglePendingRatingTasksModal() {
    setIsPendingRatingTasksOpen(!isPendingRatingTasksOpen);
  }

  React.useEffect(() => {
    getPendingRatingTasks();
    getAllOveralltaskCount();
    getAllMemberwise();
    if (localStorage.getItem("role") === "ROLE_SUPER_ADMIN" || localStorage.getItem("role") === "ROLE_ADMIN") {
      getOverallAttendanceData(attendanceDate);
      getMonthlyAttendance(dayjs());
    }
  }, []);

  function getMonthlyAttendance(month = attendanceMonth) {

    const start = month.startOf("month").format("YYYY-MM-DD");

    const end = month.isSame(dayjs(), "month")
      ? dayjs().format("YYYY-MM-DD")
      : month.endOf("month").format("YYYY-MM-DD");

    getOverallAttendance(start, end)
      .then(resp => {
        if (resp.status === 401) {
          logout();
          return;
        }
        return resp.json();
      })
      .then(data => {

        const chartData = (data || []).map(e => ({
          date: dayjs(e.date).format("DD MMM"),
          Present: e.presentMembersCount,
          Absent: e.absentMembersCount
        }));

        setMonthlyAttendance(chartData);

      })
      .catch(console.error);
  }

  const handlePreviousMonth = () => {

    const previous = attendanceMonth.subtract(1, "month");

    setAttendanceMonth(previous);

    getMonthlyAttendance(previous);

  };

  const handleNextMonth = () => {

    const next = attendanceMonth.add(1, "month");

    if (next.isAfter(dayjs(), "month")) return;

    setAttendanceMonth(next);

    getMonthlyAttendance(next);

  };
  const handleCurrentMonth = () => {

    const current = dayjs();

    setAttendanceMonth(current);

    getMonthlyAttendance(current);

  };

  function getPendingRatingTasks() {
    getPendingRatingTaskList().then(resp => {
      if (resp.status === 401) logout();
      resp.json().then(data => {
        setPendingRatingTasks(data);
        if (data && data.length > 0) togglePendingRatingTasksModal();
      });
    }).catch(error => console.log("login user err " + error));
  }

  function getOverallAttendanceData(date = attendanceDate) {
    getOverallAttendance(date, date).then((resp) => {
      if (resp.status === 401) {
        logout(); return;
      } return resp.json();
    }).then((data) => {
      setoverallAttendance(data ?? []);
    }).catch((error) => {
      console.log("get overall attendance error:", error);
    });
  }

  const handlePreviousAttendance = () => {
    const previous = dayjs(attendanceDate).subtract(1, "day").format("YYYY-MM-DD");
    setAttendanceDate(previous);
    getOverallAttendanceData(previous);
  };

  const handleNextAttendance = () => {
    const next = dayjs(attendanceDate).add(1, "day").format("YYYY-MM-DD");

    // Don't allow dates after today
    if (dayjs(next).isAfter(dayjs(), "day")) return;

    setAttendanceDate(next);
    getOverallAttendanceData(next);
  };

  const handleTodayAttendance = () => {
    const today = dayjs().format("YYYY-MM-DD");

    // Avoid unnecessary API call if already on today
    if (attendanceDate === today) return;

    setAttendanceDate(today);
    getOverallAttendanceData(today);
  };

  function getAllOveralltaskCount() {
    getOverallTaskCount().then(resp => {
      if (resp.status === 401) logout();
      resp.json().then(data => setOverallCount(data));
    }).catch(error => console.log("login user err " + error));
  }

  function getAllMemberwise() {
    getAllMemberTaskTimeData().then(resp => {
      if (resp.status === 401) logout();
      resp.json().then(data => {
        let respdata = [];
        if (data && data.length > 0) {
          data.map(e => {
            let memberwiseBarChartData = {
              member: '', inprogressEstimatedTime: '', actualInprogressTime: '',
              qcEstimatedTime: '', actualQcTime: '', inprogressEfficiencyPercentage: '',
              qcEfficiencyPercentage: '', inprogressReworkCount: ''
            };
            memberwiseBarChartData.member = e.name + " (" + e.memberId + ")";
            memberwiseBarChartData.inprogressEstimatedTime = convertSecondsToHoursAndMinutes(e.inprogressEstimatedTime);
            memberwiseBarChartData.actualInprogressTime = convertSecondsToHoursAndMinutes(e.actualInprogressTime);
            memberwiseBarChartData.qcEstimatedTime = convertSecondsToHoursAndMinutes(e.qcEstimatedTime);
            memberwiseBarChartData.actualQcTime = convertSecondsToHoursAndMinutes(e.actualQcTime);
            memberwiseBarChartData.inprogressEfficiencyPercentage = e.inprogressEfficiencyPercentage;
            memberwiseBarChartData.qcEfficiencyPercentage = e.qcEfficiencyPercentage;
            memberwiseBarChartData.inprogressReworkCount = e.inprogressReworkCount;
            respdata.push(memberwiseBarChartData);
          })
        }
        setMemberwiseData(respdata);
      });
    }).catch(error => console.log("login user err " + error));
  }

  function convertSecondsToHoursAndMinutes(seconds) {
    const totalMinutes = Math.floor(seconds / 60);
    const hours = Math.floor(totalMinutes / 60);
    const remainingMinutes = totalMinutes % 60;
    return Number(`${hours}.${remainingMinutes}`);
  }

  function getAllTeamwise() {
    getAllTeamwiseData().then(resp => {
      if (resp.status === 401) logout();
      resp.json().then(data => {
        let eachTeam = [];
        if (data && data.length > 0) {
          data.map(t => {
            let memberArr = [];
            t.members.map(e => {
              memberArr.push({
                member: e.member.firstName + " " + e.member.lastName,
                completionPercentage: e.taskCounts.completionPercentage,
                todoPercentage: e.taskCounts.todoPercentage,
                inprogressPercentage: e.taskCounts.inprogressPercentage,
                qaPercentage: e.taskCounts.qaPercentage,
                donePercentage: e.taskCounts.donePercentage
              });
            });
            eachTeam.push({ teamName: t.teamName, members: memberArr });
          })
        }
        setTeamwiseData(eachTeam);
      });
    }).catch(error => console.log("login user err " + error));
  }

  const statCards = overAllCount ? [
    { key: 'tasksInTodoPercentage', count: 'tasksInTodo', label: 'Todo Tasks', accent: '#0B6BCB' },
    { key: 'tasksInProgressPercentage', count: 'tasksInProgress', label: 'In Progress', accent: '#7c3aed' },
    { key: 'tasksInQAPercentage', count: 'tasksInQA', label: 'QA Tasks', accent: '#d97706' },
    { key: 'tasksInDonePercentage', count: 'tasksInDone', label: 'Done Tasks', accent: '#16a34a' },
  ] : [];

  return (
    <div className="mx-auto max-w-[1400px]">
      {/* Page heading */}
      <div className="mb-6 flex items-center justify-between">
        <div>
          <p className="text-sm text-gray-400">Overview of task activity for the last 10 days</p>
        </div>
      </div>

      {/* ---- Section: Stat cards ---- */}
      <section className="mb-6">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-4 xl:grid-cols-4">
          {overAllCount ? (
            statCards.map((card) => {
              const value = parseFloat(overAllCount[card.key]) || 0;
              return (
                <div
                  key={card.key}
                  className="flex items-center gap-4 rounded-2xl border border-gray-100 bg-white p-5 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
                >
                  <AnimatedProgressProvider valueStart={0} valueEnd={value} duration={1} easingFunction={easeQuadInOut}>
                    {(val) => {
                      const roundedValue = Math.round(val);
                      return (
                        <div style={{ width: 76, height: 76 }} className="shrink-0">
                          <CircularProgressbar
                            value={val}
                            text={`${roundedValue}%`}
                            strokeWidth={12}
                            styles={{
                              path: { stroke: card.accent, strokeLinecap: 'round', transition: 'stroke-dashoffset 0.5s ease 0s', transformOrigin: 'center center' },
                              trail: { stroke: '#F0F4F8', transformOrigin: 'center center' },
                              text: { fill: '#1f2937', fontSize: '22px', fontWeight: 700 },
                            }}
                          />
                        </div>
                      );
                    }}
                  </AnimatedProgressProvider>

                  <div className="min-w-0 flex-1">
                    <p className="text-[11px] font-bold uppercase tracking-wide" style={{ color: card.accent }}>
                      {card.label}
                    </p>
                    <p className="mt-1 text-2xl font-bold text-gray-900">
                      <CountUp start={1} end={overAllCount[card.count] || 0} duration={1.5} separator=" " />
                    </p>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="col-span-full flex items-center justify-center rounded-2xl border border-gray-100 bg-white py-16 shadow-sm">
              <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-[#262673]" />
            </div>
          )}
        </div>
      </section>

      {/* ---- Section: Charts ---- */}
      <section>
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          <div className="xl:col-span-8 sm:grid-cols-8">
            {memberwiseData && memberwiseData.length > 0 && (
              <BarChartStacked dbData={memberwiseData} title={"Employeewise Task Report"} subTitle={"For last 10 days"} />
            )}
          </div>
          <div className="xl:col-span-4 h-[645px]">
            {overallAttendance && overallAttendance.length > 0 && (
              <PieChartForAttendance dbData={overallAttendance}
                attendanceDate={attendanceDate}
                onPrevious={handlePreviousAttendance}
                onNext={handleNextAttendance}
                onToday={handleTodayAttendance}
              />
            )}
          </div>
        </div>
      </section>
      <section className="mt-6">
        <MonthlyAttendanceChart
          data={monthlyAttendance}
          attendanceMonth={attendanceMonth}
          onPrevious={handlePreviousMonth}
          onNext={handleNextMonth}
          onCurrentMonth={handleCurrentMonth}
        />
      </section>

      {/* Pending rating tasks modal */}
      {isPendingRatingTasksOpen && (
        <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/40 px-4 py-10 backdrop-blur-sm">
          <div className="w-full max-w-[1100px] overflow-hidden rounded-2xl bg-white shadow-2xl">
            <div className="flex items-center justify-between border-b border-gray-100 bg-red-50 px-6 py-4">
              <div className="flex items-center gap-2 text-red-600">
                <IoWarningOutline size={20} />
                <p className="text-sm font-bold tracking-wide">Pending rating tasks</p>
              </div>
              <button onClick={togglePendingRatingTasksModal} className="flex h-7 w-7 items-center justify-center rounded-full text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-700">
                <IoClose size={18} />
              </button>
            </div>
            <div className="max-h-[500px] overflow-y-auto p-5">
              <PendingRatingTasks togglePendingRatingTasksModal={togglePendingRatingTasksModal} data={pendingRatingTasks} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}